import React from 'react';
import { AccordionRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRuleHeader';
import { useGetItemRestrictionsSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/ItemRestrictionsRule/hooks/useGetItemRestrictionsSubheader';

export interface ItemRestrictionsRuleHeaderProps {
  isActive: boolean;
}

export function ItemRestrictionsRuleHeader({
  isActive,
}: ItemRestrictionsRuleHeaderProps): JSX.Element {
  const { subheader } = useGetItemRestrictionsSubheader();

  return (
    <AccordionRuleHeader
      showSubheader={!isActive}
      header="Item Restrictions"
      subheader={subheader}
    />
  );
}
